/**
 * Версия используемого API.
 */
export const API_VERSION = '1.1.0';

// v1.1.0 - в ряд методов добавлен параметр captcha
